import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { AutomationTemplateViewModel, IAccount } from '@ViewModels';
import { css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { IImpersonationContextComponentProps, ImpersonationContextKey } from '../../../../../models';
import { IAdminUserSessionComponentProps } from '../../../../../models/AdminModels';
import { UserSessionViewModelKey } from '../../../../../models/AppState';
import { AdminAutomationTemplatesViewModel } from '../../../../../viewmodels/AdminViewModels';
import { Automations } from '../../../../../web/containers/Automations';
import { styleSheet } from './styles';

interface IProps
	extends IEventLoggingComponentProps,
		RouteComponentProps<any>,
		IAdminUserSessionComponentProps,
		IImpersonationContextComponentProps {
	account: IAccount;
}

class _AccountAutomationsTab extends React.Component<IProps> {
	private mAccountAutomations: AdminAutomationTemplatesViewModel;

	constructor(props: IProps) {
		super(props);

		this.mAccountAutomations = new AdminAutomationTemplatesViewModel(props.userSession);
		this.mAccountAutomations?.impersonate({
			account: props.account,
		});
	}

	public render() {
		const { account, ...restProps } = this.props;
		return (
			<div className={css(styleSheet.container)}>
				<Automations
					account={account}
					automationTemplates={this.mAccountAutomations}
					createAutomationButtonStyles={[styleSheet.createButton]}
					headerStyles={[styleSheet.header]}
					hideAppBarHeader={true}
					hideDescription={true}
					hideOnHoldAutomations={true}
					onRequestCreate={this.onRequestCreate}
					onRequestEdit={this.onRequestEdit}
					styles={[styleSheet.automationsContainer]}
					{...restProps}
				/>
			</div>
		);
	}

	private onRequestCreate = () => {
		this.props.history.push(`${this.props.match.url}/automations/new`);
		return true;
	};

	private onRequestEdit = (automationTemplate: AutomationTemplateViewModel) => {
		this.props.history.push(`${this.props.match.url}/automations/${automationTemplate.id}`);
		return true;
	};

	public componentDidMount() {
		this.mAccountAutomations.load();
	}
}

const AccountAutomationsTabAsObserver = observer(_AccountAutomationsTab);
const AccountAutomationsTabWithContext = inject(
	UserSessionViewModelKey,
	ImpersonationContextKey
)(AccountAutomationsTabAsObserver);
const AccountAutomationsTabWithLogging = withEventLogging(AccountAutomationsTabWithContext, 'AccountAutomationsTab');
export const AccountAutomationsTab = withRouter(AccountAutomationsTabWithLogging);
